import { render, staticRenderFns } from "./AllList.vue?vue&type=template&id=d8bc84b8&scoped=true"
import script from "./AllList.vue?vue&type=script&lang=ts"
export * from "./AllList.vue?vue&type=script&lang=ts"
import style0 from "./AllList.vue?vue&type=style&index=0&id=d8bc84b8&prod&lang=css"
import style1 from "./AllList.vue?vue&type=style&index=1&id=d8bc84b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bc84b8",
  null
  
)

export default component.exports